import { render, staticRenderFns } from "./volunteer-center.vue?vue&type=template&id=4256b474&"
import script from "./volunteer-center.vue?vue&type=script&lang=js&"
export * from "./volunteer-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports